import { useAppTheme } from '@/shared/theme';
import { SxProps, Theme } from '@mui/material';

export function useDataTableTheme() {
  const { theme } = useAppTheme();
  const tokens = theme.dataTable;

  const getContainerSx = (): SxProps<Theme> => ({
    border: `1px solid ${tokens.container.border}`,
    borderRadius: tokens.container.borderRadius,
    bgcolor: tokens.container.background,
    overflowX: 'auto',
    // overflowY는 DataTable에서 직접 제어
  });

  const getHeaderSx = (): SxProps<Theme> => ({
    bgcolor: tokens.header.background,
    borderBottom: `1px solid ${tokens.header.border}`,
    '& .MuiTableCell-root': {
      borderBottom: `1px solid ${tokens.header.border}`,
      color: tokens.header.text.default,
      fontWeight: tokens.header.text.fontWeight,
    },
  });

  const getRowSx = (isHovered?: boolean, isSelected?: boolean): SxProps<Theme> => ({
    bgcolor: tokens.body.background,
    '&:hover': isHovered
      ? {
          bgcolor: tokens.body.row.hover,
        }
      : undefined,
    ...(isSelected && {
      bgcolor: tokens.body.row.selected,
    }),
  });

  const getCellSx = (): SxProps<Theme> => ({
    padding: tokens.cell.padding,
    minHeight: tokens.cell.minHeight,
    color: tokens.cell.text.default,
    borderBottom: `1px solid ${tokens.cell.border}`,
  });

  const getExpandableSx = (): SxProps<Theme> => ({
    bgcolor: tokens.expandable.background,
    borderBottom: `1px solid ${tokens.expandable.border}`,
  });

  return {
    tokens,
    getContainerSx,
    getHeaderSx,
    getRowSx,
    getCellSx,
    getExpandableSx,
  };
}
